import { EventObject } from '@xstate/store-react';
import { StoreContext } from '../../models/store/context';
import { AppRoute } from '../../enums/appRoutes';
import { StoreEvent } from '../../enums/storeEvent';
import { log } from '@domgen/shared/utils/log';
import { StepKey } from '../../enums/stepKey';

/**
 * Handles the RESTART_JOURNEY event.
 *
 * Clears all appliance-specific form data and derived state (quote, checkout,
 * confirmation, appliance lookup results) while preserving the user's personal
 * details so they do not have to re-enter them. Navigates to the start of the
 * appliance details step.
 *
 */
export const restartJourney = <T extends EventObject = EventObject>(
  context: StoreContext,
  _event: T,
  enqueue: {
    effect: (effect: () => Promise<void>) => void;
    emit: { navigate: (payload: { path: AppRoute; replace?: boolean }) => void };
  },
): StoreContext => {
  log.debug({ message: StoreEvent.RESTART_JOURNEY });

  enqueue.emit.navigate({ path: AppRoute.LANDING, replace: true });

  const newForm: Partial<StoreContext['form']> = {};

  if (context.form[StepKey.PERSONAL_DETAILS]) {
    newForm[StepKey.PERSONAL_DETAILS] = context.form[StepKey.PERSONAL_DETAILS];
  }

  return {
    ...context,
    form: newForm,
    quote: undefined,
    checkout: undefined,
    confirmation: undefined,
    applianceLookupResults: undefined,
    gaEventData: undefined,
  };
};
